export function AdminFooter() {
  return (
    <footer className="fixed bottom-0 left-64 right-0 bg-white border-t border-gray-200 py-2 px-4 text-center text-sm text-gray-600">
      <p>Painel Administrativo v1.0.0</p>
    </footer>
  );
}